import axios from 'axios';

export const SET_PROVIDERS = 'SET_PROVIDERS';
export const setProviders = providers => ({
	type: SET_PROVIDERS,
	payload: providers
});

export const SET_HASH = 'SET_HASH';
export const setHash = hash => ({
	type: SET_HASH,
	payload: hash
});

export const CLEAR_PROVIDER_REDUCER = 'CLEAR_PROVIDER_REDUCER';
export const clearProviderReducer = () => ({
	type: CLEAR_PROVIDER_REDUCER
});

export const getProviders = () => dispatch => {
	const request = axios.get('/api/providers');
	return request
		.then(res => dispatch(setProviders(res.data)))
		.catch(err => console.error({ ...err, location: 'providers' }));
};

export const getHash = () => dispatch => {
	const request = axios.get('/api/instance-sizes-hash');
	return request.then(res => dispatch(setHash(res.data))).catch(err => console.error({ ...err, location: 'hash' }));
};

export const SET_CONECT = 'SET_CONECT';
export const setConnect = connect => ({
	type: SET_CONECT,
	payload: connect
});

export const SET_CHANGE_DB_CLUSTERS = 'SET_CHANGE_DB_CLUSTERS';
export const setChangeDbClusters = changed => ({
	type: SET_CHANGE_DB_CLUSTERS,
	payload: changed
});

export const SET_CHANGE_DB_NODES = 'SET_CHANGE_DB_NODES';
export const setChangeDbNodes = changed => ({
	type: SET_CHANGE_DB_NODES,
	payload: changed
});

export const SET_CHANGE_DB_QUEUEDJOB = 'SET_CHANGE_DB_QUEUEDJOB';
export const setChangeDbQueuedjob = changed => ({
	type: SET_CHANGE_DB_QUEUEDJOB,
	payload: changed
});

export const SET_CHANGE_DB_CLUSTERHEALTH = 'SET_CHANGE_DB_CLUSTERHEALTH';
export const setChangeDbClusterHealth = changed => ({
	type: SET_CHANGE_DB_CLUSTERHEALTH,
	payload: changed
});
